import { gql } from '@apollo/client'
import { useContext } from 'react'

import { ChooseFrequencyLaterSteps } from '../choose-frequency-later-steps'
import { BoxLockContext } from '../context'
import { ModalLock } from '../dynamic-multiple-offers-switch-frequency-new-benefits-lock/components/modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  DynamicMultipleOffersChooseFrequencyLaterLock_OfferLockDataFragment,
  DynamicMultipleOffersChooseFrequencyLaterLock_ViewerFragment,
} from './__generated__/dynamic-multiple-offers-choose-frequency-later-lock.graphql'

export interface DynamicMultipleOffersChooseFrequencyLaterLockProps {
  offerLockData: DynamicMultipleOffersChooseFrequencyLaterLock_OfferLockDataFragment
  viewer: DynamicMultipleOffersChooseFrequencyLaterLock_ViewerFragment
}

export function DynamicMultipleOffersChooseFrequencyLaterLock({
  offerLockData,
  viewer,
}: DynamicMultipleOffersChooseFrequencyLaterLockProps) {
  const { componentType } = useContext(BoxLockContext)

  const content = (
    <ChooseFrequencyLaterSteps
      offerLockData={offerLockData}
      viewer={viewer}
      componentType={componentType}
    />
  )

  switch (componentType) {
    case 'paywall':
      return <PaywallLock offerLockData={offerLockData}>{content}</PaywallLock>
    case 'modal':
      return (
        <ModalLock
          offerLockData={offerLockData}
          size={offerLockData.body?.cards?.length < 3 ? 'md' : 'lg'}
        >
          {content}
        </ModalLock>
      )
    default:
      return null
  }
}

DynamicMultipleOffersChooseFrequencyLaterLock.fragments = {
  offerLockData: gql`
    fragment DynamicMultipleOffersChooseFrequencyLaterLock_offerLockData on OfferLockData {
      ...PaywallLock_offerLockData
      ...NewModalLock_offerLockData
      ...ChooseFrequencyLaterSteps_offerLockData
    }
    ${PaywallLock.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
    ${ChooseFrequencyLaterSteps.fragments.offerLockData}
  `,
  viewer: gql`
    fragment DynamicMultipleOffersChooseFrequencyLaterLock_viewer on Profile {
      ...ChooseFrequencyLaterSteps_viewer
    }
    ${ChooseFrequencyLaterSteps.fragments.viewer}
  `,
}
